export const REPORTS_PAGE = () => "/operacoes/relatorios";
